import { asyncAction, action } from 'now-frontend-shared/utils/actions';

// async actions
export const getBuyerAgreementTemplate = asyncAction('buyerAgreementTemplate/GET_BUYER_AGREEMENT_TEMPLATE');

// sync action
export const reset = action('buyerAgreementTemplate/RESET');
